import script from "./StatsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsSection.vue?vue&type=script&setup=true&lang=js"

import "./StatsSection.vue?vue&type=style&index=0&id=a3f315a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3f315a6"]])

export default __exports__